import { ConfigProvider, Form } from 'antd';
import { FormikProvider, FormikProps } from 'formik';

import { Checkbox, FormikCheckboxGroup, Text } from 'shared/components/ui';
import { FormikSelectWithoutChoice } from 'shared/components/ui';
import { SearchSelect } from 'features/search/components';
import { useGetCountriesQuery, useGetLocationsQuery } from 'services';
import { CompanySearchFormParams } from 'features/technographics/models';
import { Headcount } from 'shared/generated-models';

import styles from './index.module.scss';

export const CompaniesFilters = ({ formik }: { formik: FormikProps<CompanySearchFormParams> }) => {
	return (
		<ConfigProvider
			theme={{
				components: {
					Tooltip: {
						paddingSM: 0,
						paddingXS: 0,
						borderRadius: 2,
						colorBgDefault: '#f8f8f8'
					}
				}
			}}>
			<div className={styles.container}>
				<FormikProvider value={formik}>
					<Form layout="vertical" className={styles.form}>
						<div>
							<div className={styles.field}>
								<SearchSelect
									label="City or state"
									name="city"
									useQuery={useGetLocationsQuery}
									placeholder="Enter City or state"
								/>
							</div>
							<div className={styles.field}>
								<SearchSelect
									label="Country"
									name="country"
									useQuery={useGetCountriesQuery}
									placeholder="Enter Country"
								/>
							</div>
							<div className={styles.field}>
								<FormikSelectWithoutChoice
									label="Company domain"
									name="company_domain"
									placeholder="Enter company domain"
								/>
							</div>
							<div className={styles.field}>
								<FormikSelectWithoutChoice
									label="Website keywords"
									name="website_keywords"
									placeholder="Enter website keywords"
								/>
							</div>
							<div className={styles.field}>
								<FormikCheckboxGroup
									name="headcount"
									label={
										<div className={styles.label} onClick={e => e.preventDefault()}>
											<Text variant="inter/15/medium">Number of employees</Text>
										</div>
									}>
									<Checkbox value={Headcount._1_10}>1-10</Checkbox>
									<Checkbox value={Headcount._11_50}>11-50</Checkbox>
									<Checkbox value={Headcount._51_200}>51-200</Checkbox>
									<Checkbox value={Headcount._201_500}>201-500</Checkbox>
									<Checkbox value={Headcount._501_1000}>501-1000</Checkbox>
									<Checkbox value={Headcount._1001_5000}>1001-5000</Checkbox>
									<Checkbox value={Headcount._5001_10000}>5001-10000</Checkbox>
									<Checkbox value={Headcount._10000_}>10000+</Checkbox>
								</FormikCheckboxGroup>
							</div>
						</div>
					</Form>
				</FormikProvider>
			</div>
		</ConfigProvider>
	);
};
